import getHighlightedElements from './highlighted-elements';

export default {
  getHighlightedElements,
};
